import { Fragment, useContext, useState } from "react";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { Button } from "rizzui";
import ParksList from "../../park/list/ParksList";
import cn from "../../../utils/classNames";
import IssuesList from "./IssuesList";


const IssuesListWrapper = () => {

    // STATES
    const [openModalForm, setOpenModalForm] = useState<boolean>(false);
    const [openModalImport, setOpenModalImport] = useState<boolean>(false);

    
    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de incidencias' },
        { name: 'Incidencias', href: '/issues' },
    ];

    const defaultFilters = {
        status: null,
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Gestión de incidencias" breadcrumb={breadCrumb}>
                    {userCan('create', 'issues') && (
                        <div className="flex flex-col md:flex-row gap-2">
                            {/*
                            <Button
                                color="primary"
                                onClick={() => { setOpenModalImport(true) }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Importar incidencias
                            </Button>
                            */}
                            <Button
                                color="primary"
                                onClick={() => { setOpenModalForm(true) }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear Incidencia
                            </Button>
                        </div>
                    )}
                </PageHeader>
                <IssuesList
                    setIsOpenModalForm={setOpenModalForm}
                    openModalForm={openModalForm}
                    setIsOpenImport={setOpenModalImport}
                    openImport={openModalImport}
                />
            </FiltersProvider>
        </Fragment>
    )

}

export default IssuesListWrapper;
